import { isAxiosError } from 'axios';
import { Result, err, ok } from 'neverthrow';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore utils is in the parent dir
import axios from '@utils/axios';

import { ApiError } from 'types/api/ApiError';
import captureException from 'utils/captureException';

import type { DraftReplyMode } from '../mailclient/interface';
import { buildQuickQuoteReplyWirePayload } from './quickQuoteReplyWire';

interface CreateQuickQuoteReplySend {
  threadItemId: string;
  draftBody: string;
  replyMode: DraftReplyMode;
  to?: string[];
  cc?: string[];
  bcc?: string[];
}

export async function createQuickQuoteReplySend({
  threadItemId,
  draftBody,
  replyMode,
  to,
  cc,
  bcc,
}: CreateQuickQuoteReplySend): Promise<Result<null, ApiError>> {
  try {
    const response = await axios.post<null>(
      `/quote/private/quickquote/send`,
      buildQuickQuoteReplyWirePayload(
        {
          threadItemId,
          draftBody,
          replyMode,
          to,
          cc,
          bcc,
        },
        axios.defaults.baseURL
      )
    );

    return ok(response.data);
  } catch (error) {
    captureException(error, { functionName: 'createQuickQuoteReplySend' });

    if (!isAxiosError(error)) {
      return err({
        message: 'Unable to send quote reply.',
      });
    }

    if (error.response?.status === 401) {
      throw error;
    }

    if (error.message === 'Extension context invalidated.') {
      throw error;
    }

    return err({
      message: error.response?.data.message || 'Unable to send quote reply.',
      changes: error.response?.data.changes,
    });
  }
}
